import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendOtp } from "../../api/authApi";
import { useTheme } from "../ChatPage/hooks/useTheme";
import { themes, createStyles } from "../ChatPage/styles";
import { formatPhoneNumber, validatePhoneNumber } from "../../utils/phoneValidation";

export default function LoginPage() {
    const navigate = useNavigate();
    const { themeName } = useTheme();
    const theme = themeName === "light" ? themes.light : themes.dark;
    const styles = createStyles(theme);

    const [phoneNumber, setPhoneNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handlePhoneChange = (e) => {
        const formatted = formatPhoneNumber(e.target.value);
        setPhoneNumber(formatted);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!phoneNumber.trim()) {
            setError("Please enter your phone number");
            return;
        }

        if (!validatePhoneNumber(phoneNumber)) {
            setError("Номер телефону повинен бути у форматі +380 XX XXX XXXX");
            return;
        }

        setLoading(true);
        try {
            await sendOtp(phoneNumber);
            navigate("/verify", { state: { phoneNumber, isRegistration: false } });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={pageStyle(theme)}>
            <div style={containerStyle(theme)}>
                <h1 style={titleStyle}>Вхід</h1>

                <form onSubmit={handleSubmit} style={formStyle}>
                    <input
                        type="tel"
                        placeholder="+380 XX XXX XXXX"
                        value={phoneNumber}
                        onChange={handlePhoneChange}
                        style={inputStyle(theme)}
                        disabled={loading}
                    />

                    {error && <div style={errorStyle}>{error}</div>}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            ...styles.button,
                            width: "100%",
                            ...(loading ? styles.disabledButton : {}),
                        }}
                    >
                        {loading ? "Відправка..." : "Продовжити"}
                    </button>
                </form>

                <div style={linkContainerStyle}>
                    <span style={linkTextStyle(theme)}>Немає акаунту? </span>
                    <button
                        onClick={() => navigate("/register")}
                        style={linkButtonStyle(theme)}
                        disabled={loading}
                    >
                        Зареєструватися
                    </button>
                </div>
            </div>
        </div>
    );
}

const pageStyle = (theme) => ({
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.bg,
    color: theme.text,
    padding: "20px",
});

const containerStyle = (theme) => ({
    width: "100%",
    maxWidth: "400px",
    padding: "32px 24px",
    borderRadius: "16px",
    background: theme.panel,
    border: `1px solid ${theme.border}`,
});

const titleStyle = {
    fontSize: "24px",
    fontWeight: "800",
    marginBottom: "24px",
    textAlign: "center",
};

const formStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
};

const inputStyle = (theme) => ({
    padding: "12px 16px",
    fontSize: "16px",
    border: `1px solid ${theme.border}`,
    borderRadius: "12px",
    background: theme.inputBg,
    color: theme.text,
    outline: "none",
});

const errorStyle = {
    color: "#ff4444",
    fontSize: "14px",
    textAlign: "center",
};

const linkContainerStyle = {
    marginTop: "20px",
    textAlign: "center",
};

const linkTextStyle = (theme) => ({
    fontSize: "14px",
    color: theme.muted,
});

const linkButtonStyle = (theme) => ({
    fontSize: "14px",
    color: theme.buttonBg,
    background: "none",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    padding: "0",
});
